function createMobileDropdownTabController(UIExtension){
    let module = UIExtension.modular.module('online');

    class MobileDropdownTabController extends UIExtension.Controller{
        static getName() {
            return 'MobileDropdownTabController';
        }
        constructor(component){
            super(component);
            this.currentTabName;
        }
        
        postlink() {
            const activeChild = this.component.findChildren(it => it.isActive, false)[0];
            if(activeChild) {
                this.currentTabName = activeChild.getAttribute('tab');
            }
        }
        mounted() {
            this.tabsContainer = this.getComponentByName('fv--mobile-toolbar-tabs');
            if(!this.tabsContainer) {
                throw new Error('tabs body not found!');
            }
            if(this.currentTabName) {
                this.doShowTab(this.currentTabName);
            }
        }
        doShowTab(name) {
            const tabContent = this.tabsContainer.findChildren(it => it.getAttribute('tab') == name)[0];
            if(tabContent) {
                tabContent.element.classList.add('active');
            }
        }
        doHideTab(name) {
            const tabContent = this.tabsContainer.findChildren(it => it.getAttribute('tab') == name)[0]
            if(tabContent) {
                tabContent.element.classList.remove('active');
            }
        }
        toggleTab(name) {
            const tabContent = this.tabsContainer.findChildren(it => it.getAttribute('tab') == name)[0]
            const clsList = tabContent.element.classList;
            if(clsList.contains('active')) {
                clsList.remove('active');
            } else {
                clsList.add('active');
            }
        }
        switchTab(button) {
            const tabName = button.getAttribute('tab');
            if(tabName === this.currentTabName) {
                this.toggleTab(tabName);
            } else {
                this.doHideTab(this.currentTabName);
                this.doShowTab(this.currentTabName = tabName);
                this.pdfUI.pdfViewer.eventEmitter.emit(UIExtension.UIEvents.toolbarTabsClicked, button);
            }
        }
    }

    module.registerController(MobileDropdownTabController);
}

export {
    createMobileDropdownTabController
} 